var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-home-group" }, [
    _c("h2", [_vm._v(_vm._s(_vm.page.title.rendered))]),
    _vm._v(" "),
    _c("div", { domProps: { innerHTML: _vm._s(_vm.page.content.rendered) } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib?{}!./scripts/vue/PanelHomeGroup.vue?vue&type=template&id=5419bcf0&
// module id = 63
// module chunks = 0